import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

const TypingText = ({
  animate = '',
  initial = '',
  isTyping = false,
  onAnimationComplete = () => {},
  text = '',
  variants = '',
}) => {
  const textArray = text.split('');

  const textVariants = {
    visible: {
      transition: {
        when: 'afterChildren',
        staggerChildren: 0.01,
      },
    },
  };

  const letterVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0,
      },
    },
  };

  return isTyping ? (
    <motion.span
      initial={initial || 'hidden'}
      animate={animate || 'visible'}
      variants={variants || textVariants}
      onAnimationComplete={onAnimationComplete}
    >
      {textArray.map((letter, i) => (
        <motion.span
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          initial="hidden"
          variants={letterVariants}
        >
          {letter}
        </motion.span>
      ))}
    </motion.span>
  ) : (
    // This makes sure the text being typed already as the alotted spacing
    // taken up in case it wraps to two lines
    <span style={{ opacity: 0 }}>{text}</span>
  );
};

TypingText.propTypes = {
  animate: PropTypes.string,
  initial: PropTypes.string,
  text: PropTypes.string.isRequired,
  variants: PropTypes.string,
  isTyping: PropTypes.bool.isRequired,
  onAnimationComplete: PropTypes.func,
};

export default React.memo(TypingText);
